"use client"
import { ComponentConfig } from "@measured/puck"
import { RenderDepartmentRecruitment } from "./RenderConfig"

export const DepartmentRecruitment: ComponentConfig = {
  label: "List Department Recruitment",

  ...RenderDepartmentRecruitment,
}
